import { render, staticRenderFns } from "./PaginationBase.vue?vue&type=template&id=caafea7e&scoped=true&"
import script from "./PaginationBase.vue?vue&type=script&lang=js&"
export * from "./PaginationBase.vue?vue&type=script&lang=js&"
import style0 from "./PaginationBase.vue?vue&type=style&index=0&id=caafea7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caafea7e",
  null
  
)

export default component.exports